module.exports = __webpack_public_path__ + "img/a-ziyuan6.62ebf50e.png";